export const NODE_PREFIX = '/mdf-node/'
export const PROXY_ROUTE = 'qtmProxy/'
export const META_URL = `${NODE_PREFIX}${PROXY_ROUTE}ypd/bill/meta?billnum=`
export const TPL_META_URL = `${NODE_PREFIX}${PROXY_ROUTE}ypd/bill/tplAndMeta`
export const LANGUAGE_URL = '/iuap-yonbuilder-designer/iuap-front/ide/iuap/lang/localLanguage'
export const GET_TPL_ID_URL = `${NODE_PREFIX}${PROXY_ROUTE}ypd/bill/getTplId`
export const GET_AUTH_URL = `${NODE_PREFIX}uniform/ypd/bill/generateADT`
export const RESOURCE_TYPE_FUNCTION = 'function'
export const XA01 = 'x-a01'
export const AUTH_KEY = 'dynamic_auth_token'
export const X_CHANGE_INFO = 'x_change_info'
export const GET_COMMON_OPTION = '/iuap-apcom-auth/option/getCommonOption?terminalType='

export const TAG = 'Fragment-node'
export const getTag = (alias) => `${TAG}-${alias}`

export const debugInfo = (tag, ...args) => {
  if (window?.ynf?.debug) {
    console.log(TAG + tag, args)
  }
}
export const logInfo = (tag, ...args) => {
  console.log(TAG + tag, args)
}
export const logWarn = (tag, ...args) => {
  console.warn(TAG + tag, args)
}
export const UI_AUTH_ID = 'UI#authId'
